<script>
export default {
	props: {
    title: {
      type: String,
      required: true
    },
    category: {
      type: [Array,
        String],
      default: () => {
        return [
        {
          title: '影音辨識',
          alias: 'alias',
        },
        {
          title: '語音辨識',
          alias: 'alisa2'
        }
      ]
      },
    },
	},
  
  data() {
    return {
      
    }
  }
}
</script>

<template>
  <div :class="$style.baseArticleBanner">
    <div class="baseArticleBanner__boxInner">
      <div class="baseArticleBanner__topBox">
        <div class="section pb-0">
          <div class="container">
            <div class="baseArticleBanner__top text-center color-white">
              <BaseBreadcrumb class="breadCrumb d-md-flex d-none justify-content-center"/>
              <div class="baseArticleBanner__topTitle text-xl md:text-3xl font-medium">
                {{ title }}
              </div>
              <template v-if="Array.isArray(category) && category.length > 0">
                <div class="baseArticleBanner__topCategoryBox">
                  <span 
                    v-for="(item ,$index) in category"
                    :key="$index"
                    class="baseArticleBanner__topCategory badge badge-pill text-2sm md:text-base font-medium bg-white color-primary mx-2"
                  >
                    {{ item.title }}
                  </span>
                </div>
                
              </template>

              <span v-else class="baseArticleBanner__topCategory badge badge-pill text-2sm md:text-base font-medium bg-white color-primary">
                {{ category }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="baseArticleBanner__bottomBox pt-md-5 pt-3">
        <div class="container">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.baseArticleBanner {
  // margin-bottom: 12%;
  :global {
    .baseArticleBanner{
      &__boxInner {
        background: transparent linear-gradient(to bottom , transparent 70%, #fff 70% ) 0% 0% no-repeat padding-box;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          height: 70%;
          background: transparent linear-gradient(250deg, rgba(171, 205, 3, 1) 0%, rgba(0, 120, 212, 1) 100%) 0% 0% no-repeat padding-box;
        }
      }
      &__top {
        position: relative;
        z-index: 3;
        // background: transparent linear-gradient(250deg, rgba(171, 205, 3, 1) 0%, rgba(0, 120, 212, 1) 100%) 0% 0% no-repeat padding-box;
      }
      &__topCategoryBox {
        max-width: 730px;
        width: 100%;
        margin: 0 auto;
      }
      &__topCategory {
        margin-top: 1rem;
        padding: 0.6rem 1.4rem; 
        min-width: 120px;
        width: auto;
        @include max-md {
          min-width: auto;
          margin-top: 0.8rem;
          padding: 0.4rem 0.8rem; 
        }
      }
      &__bottomBox {
        position: relative;
        z-index: 3;
        // padding-top: 2%;
        // padding-bottom: 30%;
        .content {
          // position: absolute;
        }
        // .imageBg {
        //   background-size: 20%;
        //   background-repeat: no-repeat;
        //   background-position: center;
        // }
      }
    }
  }
}
</style>